import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Chemical = props => (
  <SvgIcon {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Keyword-Up" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-spellcheck-24px">
          <path
            d="M 16.164062 0.800781 C 16.164062 0.363281 15.816406 0.0078125 15.375 0 L 8.664062 0 C 8.222656 0 7.867188 0.359375 7.867188 0.800781 C 7.867188 1.242188 8.222656 1.601562 8.664062 1.601562 C 8.664062 1.601562 8.664062 1.601562 8.667969 1.601562 L 15.375 1.601562 C 15.816406 1.59375 16.164062 1.238281 16.164062 0.800781 Z M 16.164062 0.800781"
            id="Shape"
          />
          <path
            d="M 19.152344 16.492188 C 17.84375 17.1875 16.394531 17.5625 14.914062 17.585938 C 13.859375 17.597656 12.820312 17.351562 11.878906 16.875 C 8.75 15.265625 5.007812 16.875 4.972656 16.875 L 4.9375 16.886719 L 4.570312 17 L 1.894531 21.304688 C 0.960938 22.808594 1.640625 24.035156 3.410156 24.035156 L 20.632812 24.035156 C 22.402344 24.035156 23.09375 22.804688 22.152344 21.304688 Z M 19.152344 16.492188"
            id="Shape2"
          />
          <path
            d="M 9.054688 2.261719 L 14.988281 2.261719 L 14.988281 3.285156 L 9.054688 3.285156 Z M 9.054688 2.261719"
            id="Shape3"
          />
          <path
            d="M 12.171875 16.300781 C 15.175781 17.832031 18.507812 16.089844 18.796875 15.9375 L 14.988281 9.808594 L 14.988281 3.941406 L 9.054688 3.941406 L 9.054688 9.808594 L 5.117188 16.128906 C 6.238281 15.730469 9.367188 14.859375 12.171875 16.300781 Z M 12.171875 16.300781"
            id="Shape4"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Chemical



// WEBPACK FOOTER //
// ./src/icons/Chemical.js